import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------credit api's-------------------------------->
    /**
     * credit index page
     * @param {} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getCredits(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/credit/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getCreditExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/credit/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getCreditsApprove(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/statusapproval', data)
    },

    /**
     * create api 
     * @param {*} form 
     */
    postCredit(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/create', form)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getCredit(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/credit/view/' + id)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postCreditUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/update/' + id, form)
    },
    /**
     * credtis deails
     */
    getCreditDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/credit/CreditDetails')
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postCreditRefundUpdate(id, form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/creditRefund/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postCreditRefundDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/refunddelete/' + id)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getCreditView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/credit/viewpage/' + id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getCreditDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/singledelete/', data)
    },


    /**
     * 
     * @param {*} data 
     */
    postFiltercreateCredit(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateCredit(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteCredit(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/filterdelete', data)
    },
    /**
     * bulk delete api 
     */
    postCreditBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/bulkdelete', data)
    },

    getCreditCancel(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/cancel', data)
    },
    addeway(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/credit/EwayBillCreate', data)
    },

}